
import { computed, defineComponent, ref } from 'vue';
import { OioForm, OioFormItem, OioInput, OioButton } from '@kunlun/vue-ui-antd';

export default defineComponent({
  name: 'ProductProperty',
  components: {
    OioForm,
    OioFormItem,
    OioInput,
    OioButton
  },
  props: ['focus', 'blur', 'data', 'customData', 'formRef', 'cateAttrs'],
  setup(props) {
    const curAttr = computed(() => (key: string) => props.cateAttrs.find((i) => i.name === key));
    const formData = computed(() => {
      const result = {};
      Object.values(props.data).forEach((obj) => {
        Object.assign(result, obj);
      });
      return result;
    });

    return {
      curAttr,
      formData
    };
  }
});
